export const LABELS = {
  TITLE: 'Profile completion',
  SUBTITLE: 'Get the most out of Sorted',
  SHOW_PROGRESS: 'Show progress',
  VERIFIED: 'Background check',
  EXPIRED: 'Check expired',
};
